import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {BranchModel} from "../../models/branch.model";
import {BranchesFilterModel} from "../models/branches-filter.model";

@Injectable({providedIn: 'root'})
export class BranchesHttpService {

  private base_url = `/branches`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  query(filter: BranchesFilterModel, params?: any): Observable<{ cursor: string, list: BranchModel[] }> {
    return this.http
      .post<{ cursor: string, list: BranchModel[] }>(`${this.base_url}/query`, filter, {params});
  }

}
